export class DateTools {
  static match(date: Date, match: Date): boolean {
    return this.getDateString(date) === this.getDateString(match);
  }

  static getDateString(date: Date): string {
    if (isNaN(date.getTime())) {
      throw 'INVALID DATE';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1)
      .padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate())
      .padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  static createDate(dateString: string): Date {
    return new Date(dateString.split('T')[0]);
  }

  static stringToDate(date: string | null | undefined): Date | undefined {
    if (!date || !DateTools.isValidDate(date)) {
      return undefined;
    }
    const d = Date.parse(date);
    if (!isNaN(d)) {
      return new Date(d);
    }
    const dateArray = date.split('-');
    dateArray[1] = dateArray[1].padStart(2, '0');
    dateArray[2] = dateArray[2].padStart(2, '0');
    const fixedD = Date.parse(dateArray.join('-'));
    if (!isNaN(fixedD)) {
      return new Date(fixedD);
    }
    return undefined;
  }

  static isValidDate(dateString: string): boolean {
    const regex = /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/;
    return regex.test(dateString);
  }
}
